const config = {
    API_BASE_URL: 'https://api.coloniume.org',
    EXPLORER_BASE_URL: 'https://coloniume.io/api',
    // API_BASE_URL: 'http://127.0.0.1:3001',
};

export default config;